import { AtlasContext, AtlasProviderProps } from './context'
import { MaterializedFeature } from '@dtx-company/connect-codegen/src/gen/plans/v1/plans_pb'
import { initializeAtlasUsage } from '@dtx-company/inter-app/src/utils/atlas/initAtlasUsage'
import { useAtlasFeatureFlag } from '../../hooks/atlas/useAtlasFeatureFlag'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import React, { useEffect } from 'react'

export const AtlasProvider: React.FC<AtlasProviderProps> = ({ children }): JSX.Element => {
  const [data, setData] = React.useState<{ [key: string]: MaterializedFeature }>({})
  const { jwt } = useAuthState()
  const atlasEnabled = useAtlasFeatureFlag()

  useEffect(() => {
    if (atlasEnabled && jwt) {
      initializeAtlasUsage(jwt).then(
        (atlasData: { [key: string]: MaterializedFeature } | void) =>
          atlasData && setData(atlasData)
      )
    }
  }, [atlasEnabled, jwt])

  return (
    <AtlasContext.Provider value={{ usage: data }}>
      <>{children}</>
    </AtlasContext.Provider>
  )
}
